
import { KTSVG, toAbsoluteUrl } from '../../../../../_dashboard/helpers'
import { useLang } from '../../../../../_dashboard/i18n/Metronici18n'
import { useListView } from '../core/ListViewProvider'
import {HotelsListFilter} from './HotelListFilter'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { useAuth } from '../../../../modules/auth'
import { createOne } from '../../../../services/common_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'

const HotelsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const {auth} = useAuth()
  const intl = useIntl()
  const {refetchData} = useQueryResponse()
  const [isSyncing, setIsSyncing] = useState(false)
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }
  const languages = [
    {
      lang: 'en',
      name: 'English',
      flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
    {
      lang: 'zh',
      name: 'Mandarin',
      flag: toAbsoluteUrl('/media/flags/china.svg'),
    },
    {
      lang: 'es',
      name: 'Spanish',
      flag: toAbsoluteUrl('/media/flags/spain.svg'),
    },
    {
      lang: 'ja',
      name: 'Japanese',
      flag: toAbsoluteUrl('/media/flags/japan.svg'),
    },
    {
      lang: 'de',
      name: 'German',
      flag: toAbsoluteUrl('/media/flags/germany.svg'),
    },
    {
      lang: 'fr',
      name: 'French',
      flag: toAbsoluteUrl('/media/flags/france.svg'),
    },
  ]
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)

  const handleSyncNow = async () => {
    if (auth?.role !== 'ROLE_SUPER_ADMIN') {
      return
    }
    try {
      setIsSyncing(true)
      const response = await createOne({}, '/hotels/sync-now')
      if (response?.payload?.code === 2021) {
        toast.success(
          intl.formatMessage({id: 'ADMIN.COMMON.SUCCESS.HOTEL_UPDATED_SUCCESSFULLY'}),
          {position: 'top-right', autoClose: 4000},
        )
        refetchData()
      } else {
        toast.error(intl.formatMessage({id: 'ADMIN.COMMON.ERROR.HOTEL_UPDATED'}), {
          position: 'top-right',
          autoClose: 4000,
        })
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Hotel sync failed', {
        position: 'top-right',
        autoClose: 4000,
      })
    } finally {
      setIsSyncing(false)
    }
  }

  return (
    <div className='d-flex justify-content-end' data-kt-hotel-table-toolbar='base'>
        {/* begin::Filter */}
       {/* <HotelsListFilter />*/}
          {/* end::Filter */}

      {/* begin::Export */}
      {/*<button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        Export
      </button>*/}
      {/* end::Export */}

      {/* begin::Add user */}
      {auth?.role === 'ROLE_SUPER_ADMIN' && (
        <button
          type='button'
          className='btn btn-light-primary me-3'
          disabled={isSyncing}
          onClick={handleSyncNow}
        >
          {isSyncing ? 'Syncing...' : 'Sync hotels now'}
        </button>
      )}

      {/* end::Add user */}
    </div>
  )
}

export {HotelsListToolbar}
